"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Tracker_1 = require("@/classes/Tracker");
const store_1 = __importDefault(require("@/store"));
const routes_1 = require("@/enums/routes");
const ImageLoader_1 = require("@/classes/ImageLoader");
class Question {
    constructor() {
        this.question = (0, vue_1.computed)(() => {
            return store_1.default.getters.question(this.router.props.questionId);
        });
        this.progress = (0, vue_1.computed)(() => {
            return (this.questionNumber.value + 1) / this.questionTotal * 100;
        });
        this.questionOptionClass = (0, vue_1.computed)(() => {
            const amountOfOptions = this.question.value.options.length;
            if (amountOfOptions < 5) {
                return "QuestionOptionWide";
            }
            else if (amountOfOptions < 7) {
                return "QuestionOptionMedium";
            }
            else {
                return "QuestionOptionNarrow";
            }
        });
        this.router = store_1.default.getters.router();
        this.questionNumber = (0, vue_1.ref)(this.router.props.questionId);
        this.questionTotal = 9;
    }
    preloadNextQuestionImages() {
        // Make sure, before continuing, that there is a next question to pre-load.
        if (this.questionNumber.value > this.questionTotal - 2) {
            return;
        }
        ImageLoader_1.ImageLoader.preload(this.questionNumber.value + 1);
    }
    ;
    countrySelected(iso) {
        this.answerQuestion(iso);
    }
    ;
    answerQuestion(answer) {
        const answerObject = {
            id: this.questionNumber.value,
            answer: answer
        };
        this.trackQuestionnaireMilestones();
        store_1.default.actions.answerQuestion(answerObject);
        this.routeToNextQuestion(answer);
    }
    ;
    routeToNextQuestion(answer) {
        if (this.question.value.type === 'educationLevel') {
            store_1.default.actions.setPreferredPortal(answer);
            // Only track the questionnaire answers on the last question.
            this.trackQuestionnaireAnswers();
            store_1.default.mutations.setCurrentRoute(routes_1.Routes.FORM);
        }
        else {
            this.questionNumber.value++;
            store_1.default.mutations.setCurrentRoute(routes_1.Routes.QUESTION, {
                questionId: this.questionNumber.value
            });
        }
    }
    trackQuestionnaireMilestones() {
        // Track the question number starting from 1 instead of 0.
        const questionNumberStartingFromOne = this.questionNumber.value + 1;
        // Only track it when specific question numbers were reached to avoid sending too many events.
        if (![1, 2, 4, 8].includes(questionNumberStartingFromOne)) {
            return;
        }
        Tracker_1.CountryTestTracker.fireTracking('questionnaire_milestone', questionNumberStartingFromOne.toString());
    }
    ;
    trackQuestionnaireAnswers() {
        const answers = store_1.default.getters.questions().map(question => question.answer);
        Tracker_1.CountryTestTracker.fireTracking('questionnaire_answers', JSON.stringify(answers));
    }
}
exports.default = Question;
